import React, { Fragment } from "react";
import { Auth } from "./components";

export default () => {
  return (
    <Fragment>
        <Auth />
    </Fragment>
  );
};